import {
    ChangeDetectorRef,
    Component,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import moment from 'moment';
import { ReplaySubject } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { IInvoiceCycle } from '../../../contract-management/IInvoiceCycle';
import { InvoiceContractCycleModel } from '../../../data-services/invoice-contract-cycle';
import * as fromShared from '../../../shared';
import {
    FilterService,
    SelectItem,
    Table
} from '../../../shared/efaact-primeng.module';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import * as fromStore from '../store';

@Component({
    selector: 'ef-invoice-management',
    templateUrl: './invoice-management.component.html',
    styleUrls: ['./invoice-management.component.scss'],
    standalone: false
})
export class InvoiceManagementComponent
    extends fromShared.EditGrid<fromStore.Invoice.Invoice>
    implements OnInit, OnChanges
{
    loading = true;
    moment: any;
    @Input() invoiceCycle: IInvoiceCycle[];
    @Input() invoiceCycleDaysSelectItems: SelectItem[];
    @Output() SaveInvoiceCycle = new ReplaySubject<InvoiceContractCycleModel[]>(
        1
    );

    dropdownItemHeight = environment.dropdownItemHeight;
    virtualItems: fromStore.Invoice.Invoice[];
    public get contractsSelectItems(): SelectItem[] {
        if (this.items && this.items.length > 0) {
            return fromShared
                .uniqBy(this.items, x => x.ContractDesc)
                .map(x => ({ label: x.ContractDesc, value: x.ContractDesc }));
        } else {
            return [];
        }
    }
    icd2SelectItem: SelectItem[] = [];
    rowGroupMetadata: any = {};
    @ViewChild('dtInvoiceManagement', { static: true, read: Table })
    dataTable: Table;
    startDateFilter: any;
    endDateFilter: any;
    startOverrideDateFilter: any;
    endOverrideDateFilter: any;
    numCols = 9;
    public editing?: fromStore.Invoice.Invoice =
        {} as fromStore.Invoice.Invoice;
    clonedInvoiceSchedules: { [i: string]: fromStore.Invoice.Invoice } = {};
    @Output() SaveInvoiceSchedule = new ReplaySubject<
        fromStore.Invoice.Invoice[]
    >(1);
    showDialog = false;
    rowData: fromStore.Invoice.Invoice;
    constructor(
        private log: LoggingService,
        private filterService: FilterService,
        private cdRef: ChangeDetectorRef
    ) {
        super();
        this.moment = moment;
    }
    ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
        if (changes.items && changes.items.currentValue) {
            this.log.verbose({
                type: 'InvoiceManagementComponent:items:set',
                value: changes.items.currentValue
            });
            this.updateRowGroupMetaData(changes.items.currentValue);

            if (
                changes.items.currentValue &&
                changes.items.currentValue.length > 0
            ) {
                this.selected = [changes.items.currentValue[0]];
            }
        }
    }
    ngOnInit() {
        this.addDateRangeFilter();
    }
    updateRowGroupMetaData(data) {
        this.log.verbose({
            type: 'InvoiceManagementComponent:updateRowGroupMetaData',
            data
        });
        // this.loading = true;
        // this.cdRef.markForCheck();
        this.rowGroupMetadata = {};
        if (data) {
            for (let i = 0; i < data.length; i++) {
                const rowData = data[i];
                const field = 'ContractDesc';
                const category = rowData[field];
                if (i === 0) {
                    this.rowGroupMetadata[category] = { index: 0, size: 1 };
                } else {
                    const previousRowData = data[i - 1];
                    const previousRowGroup = previousRowData[field];
                    if (category === previousRowGroup) {
                        this.rowGroupMetadata[category].size++;
                    } else {
                        this.rowGroupMetadata[category] = { index: i, size: 1 };
                    }
                }
            }
            this.log.verbose({
                type: 'InvoiceManagementComponent:updateRowGroupMetaData',
                data,
                rowGroupMetadata: this.rowGroupMetadata
            });
            this.cdRef.markForCheck();
            this.log.verbose({
                type: 'InvoiceManagementComponent:updateRowGroupMetaData:after cdref'
            });
        }
    }
    onFilter($event) {
        this.log.verbose({
            type: 'InvoiceManagementComponent:onFilter',
            $event
        });
        // setTimeout(() => {
        this.updateRowGroupMetaData($event.filteredValue);
        // }, 50);
    }
    onSort($event: {
        data: fromStore.Invoice.Invoice[];
        field: string;
        mode: string;
        order: number;
    }) {
        this.log.verbose({
            type: 'InvoiceManagementComponent:onSort',
            $event
        });
        setTimeout(() => {
            this.updateRowGroupMetaData(
                this.dataTable.filteredValue || this.dataTable.value
            );
        }, 50);
        $event.data.sort((data1, data2) => {
            const group1 = data1.ContractDesc || '';
            const group2 = data2.ContractDesc || '';
            const field1 = data1[$event.field];
            const field2 = data2[$event.field];

            this.log.verbose({
                type: 'InvoiceManagementComponent:onSort',
                $event,
                data1,
                data2,
                group1,
                group2
            });
            if ($event.field === 'ContractDesc') {
                return group1.localeCompare(group2) * $event.order;
            }
            if (group1.localeCompare(group2) === 0) {
                if (isNaN(field1) || isNaN(field2)) {
                    return field1.localeCompare(field2) * $event.order;
                } else {
                    return (field1 - field2) * $event.order;
                }
            } else {
                return group1.localeCompare(group2); // * $event.order;
            }
        });
    }
    addDateRangeFilter() {
        this.filterService.register(
            'startDateFilter',
            (value, filter): boolean => {
                this.log.verbose({
                    type: 'InvoiceManagementComponent:startDateFilter',
                    value,
                    filter
                });
                if (value === undefined || value === null) {
                    return false;
                }
                return moment(value).isBetween(
                    moment(this.startDateFilter[0]),
                    moment(this.startDateFilter[1])
                );
                // get the from/start value
            }
        );
        this.filterService.register(
            'endDateFilter',
            (value, filter): boolean => {
                this.log.verbose({
                    type: 'InvoiceManagementComponent:endDateFilter',
                    value,
                    filter
                });
                if (value === undefined || value === null) {
                    return false;
                }
                return moment(value).isBetween(
                    moment(this.endDateFilter[0]),
                    moment(this.endDateFilter[1])
                );
                // get the from/start value
            }
        );
        this.filterService.register(
            'startOverrideDateFilter',
            (value, filter): boolean => {
                this.log.verbose({
                    type: 'InvoiceManagementComponent:startDateFilter',
                    value,
                    filter
                });
                if (value === undefined || value === null) {
                    return false;
                }
                return moment(value).isBetween(
                    moment(this.startDateFilter[0]),
                    moment(this.startDateFilter[1])
                );
                // get the from/start value
            }
        );
        this.filterService.register(
            'endOverrideDateFilter',
            (value, filter): boolean => {
                this.log.verbose({
                    type: 'InvoiceManagementComponent:endDateFilter',
                    value,
                    filter
                });
                if (value === undefined || value === null) {
                    return false;
                }
                return moment(value).isBetween(
                    moment(this.endDateFilter[0]),
                    moment(this.endDateFilter[1])
                );
                // get the from/start value
            }
        );
    }

    onEditInit($event: { data: fromStore.Invoice.Invoice }) {
        this.editing = { ...$event.data };
    }

    onRowEditInit(rowData: fromStore.Invoice.Invoice) {
        this.clonedInvoiceSchedules[rowData.Uniqueid] = { ...rowData };
        this.editing = rowData;
        this.log.verbose('onRowEditInit');
    }

    canEditScheduledEndDate(
        rowData: fromStore.Invoice.Invoice & { IsReadOnly?: boolean }
    ): boolean {
        return (
            !rowData.IsReadOnly &&
            (rowData.InvoiceAmount === null || rowData.InvoiceAmount === 0)
        );
    }

    onRowEditSave(rowData: fromStore.Invoice.Invoice) {
        this.rowData = rowData;
        if (
            rowData.ScheduledEndDate.getTime() !=
            this.clonedInvoiceSchedules[
                rowData.Uniqueid
            ].ScheduledEndDate.getTime()
        ) {
            this.showDialog = true;
        } else {
            const dataArr = [] as fromStore.Invoice.Invoice[];
            dataArr.push(rowData);
            this.SaveInvoiceSchedule.next(dataArr);
            delete this.clonedInvoiceSchedules[rowData.Uniqueid];
            delete this.editing;
        }

        this.log.verbose('onRowEditSave');
    }

    onRowEditCancel(item: fromStore.Invoice.Invoice) {
        delete this.clonedInvoiceSchedules[item.Uniqueid];
        delete this.editing;
        this.log.verbose('onRowEditCancel');
    }
    onRowSelect($event) {
        this.log.verbose({
            type: `EditGrid<${typeof this}>:onRowSelect`,
            $event,
            editing: this.editing,
            selected: this.selected
        });
        if (this.editing) {
            setTimeout(() => {
                this.selected = [this.editing];
            }, 0);
        } else {
            this.SelectItem.next($event.data);
        }
    }

    onSaveInvoiceSchedule(choice) {
        if (choice == 'yes') {
            this.rowData = {
                ...this.rowData,
                NewRow: true
            };
            const dataArr = [] as fromStore.Invoice.Invoice[];
            dataArr.push(this.rowData);
            this.SaveInvoiceSchedule.next(dataArr);
            delete this.clonedInvoiceSchedules[this.rowData.Uniqueid];
            delete this.editing;
            this.showDialog = false;
        } else {
            this.rowData = {
                ...this.rowData,
                NewRow: false
            };
            const dataArr = [] as fromStore.Invoice.Invoice[];
            dataArr.push(this.rowData);
            this.SaveInvoiceSchedule.next(dataArr);
            delete this.clonedInvoiceSchedules[this.rowData.Uniqueid];
            delete this.editing;
            this.showDialog = false;
        }
    }
}
